import useSWRImmutable from 'swr';
import { SWRResponse } from 'swr';
import {
  OmnitagSearchTagsResp,
  omnitagSearchTagsResponseZod,
} from 'packages/lib/api/omnitag/contract/omnitag-search-tags';
import { omnitagAPIGet } from 'packages/lib/api/omnitag/rest';

/** Fetches from backend the list of tags the user for which the user can search */
export const useGetSearchTagsAPI = (): SWRResponse<OmnitagSearchTagsResp> => {
  return useSWRImmutable('/vision/tag_library', (url) =>
    omnitagAPIGet(url, omnitagSearchTagsResponseZod.parse)
  );
};
